import PropTypes from "prop-types";
import dayjs from "@shared/dayjs";
import Avatar from "@shared/v2/Avatar";
import { TD, TR } from "./BusinessDashboard/Table/Table";

const UserDataRow = ({ agent, isAdmin }) => {
  const prefix = isAdmin ? "admin" : "agent";
  return (
    <TR>
      <TD>
        <a className="tw-flex tw-items-center tw-gap-[8px]" href={`/people/${agent[`${prefix}_user_path`]}`}>
          <Avatar size="medium" src={agent[`${prefix}_avatar`]} alt={agent[`${prefix}_agent`]} />
          {agent[`${prefix}_agent`]}
        </a>
      </TD>
      <TD>{agent[`${prefix}_assigned_task_count`]}</TD>
      <TD>{agent[`${prefix}_completed_task_count`]}</TD>
      <TD>{agent[`${prefix}_on_time_task_count`]}</TD>
      <TD>{agent[`${prefix}_late_task_count`]}</TD>
      <TD>{agent[`${prefix}_login_count`]}</TD>
      {agent[`${prefix}_last_login`] ? (
        <TD className="tw-text-center">{dayjs(agent[`${prefix}_last_login`]).format("MM/DD/YYYY")}</TD>
      ) : (
        <TD />
      )}
    </TR>
  );
};

UserDataRow.propTypes = {
  agent: PropTypes.shape().isRequired,
  isAdmin: PropTypes.bool.isRequired,
};

export default UserDataRow;
